module.exports = "/_next/static/images/matt-sloane-b8f7271f69b1838ca0f2bf9aea394409.jpg";